<template>
  <div class="home-box my">
    <!-- 上滑进入 -->
    <div v-show="visible" class="my-box" v-if="$store.state.toLogin">
      <div class="my-group">
        <van-image
          width="20vw"
          height="20vw"
          :src="$store.state.user.headimgurl"
          round
          fit="cover"
          class="my-img"
        />
		
		<cell
		  title="职工书屋"
		  is-link
		  style="color: #c60001;"
		  @click="toWeb('http://lnjt.ailabs.xin')"
		  v-if="btn('jtbook')"
		/>
		
		<!-- <cell
		  title="集团最美女职工推荐投票通道"
		  is-link
		  style="color: #c60001;"
		  @click="toWeb('http://vote.lnjtgh.com/ques/1.html?from=url')"
		  v-if="btn('jtbook')"
		/> -->
		
        <cell title="职工诉求" is-link @click="to('/appealList')" />
		
		
		
        <cell
            title="任务列表"
            is-link
            @click="to('/issueTask')"
            v-if="btn('onetask-approval') || btn('twotask-approval')"
        />
        <cell
            title="任务审批"
            is-link
            @click="to('/approvalTask')"
            v-if="
            btn('onetask-approval') || btn('twotask-approval')
          "
        />
        <cell
          title="本级活动"
          is-link
          @click="to('/launchEvent')"
          v-if="btn('event-release')"
        />
        <cell
          title="本级审批"
          is-link
          @click="to('/approvalActivitiesNoe')"
          v-if="
            btn('one-approval') || btn('two_approval') || btn('three_approval')
          "
        />
        <!--                    <cell title="活动审批" is-link @click="to('/approvalActivitiesTwo')" v-if="btn('two_approval')"/>-->
        <cell
          title="集团活动"
          is-link
          @click="to('/groupActivities')"
          v-if="btn('event-release')"
        />
        <cell
          title="集团审批"
          is-link
          @click="to('/groupApproval')"
          v-if="btn('one-group') || btn('two-group') || btn('three-group')"
        />
        <cell
          title="经费审批"
          is-link
          @click="to('/fundActivities')"
          v-if="
            btn('funding_approval') ||
            btn('one-group') ||
            btn('two-group') ||
            btn('three-group') ||
            btn('one-approval') ||
            btn('two_approval') ||
            btn('three_approval')
          "
        />
        <cell
          title="活动统计"
          is-link
          @click="to('/activityOverview')"
          v-if="btn('activity_statistics')"
        />
        <cell title="我的报名" is-link @click="to('/myList')" />
        <cell title="我的拼车" is-link @click="to('/myCarList')" />
        <cell title="注册车辆" is-link @click="to('/myCar')" />
      </div>
    </div>
    <div style="margin: 30px" v-else>
      <div style="text-align: center; font-size: 2rem; line-height: 10rem">
        登录
      </div>
      <ant-form validate-first @submit="onSubmit">
        <ant-field
          label="姓名："
          required
          v-model="form.username"
          placeholder="请输入内容"
        />
        <ant-field
          label="联系方式："
          v-model="form.phone"
          required
          type="tel"
          placeholder="请输入联系方式"
          :rules="[{ required: true, message: '请填写联系方式' }]"
        />
        <ant-field
          label="身份证号："
          v-model="form.idNumber"
          required
          placeholder="请输入身份证号"
          :rules="[{ required: true, message: '请填写身份证号' }]"
        />
        <div style="margin: 16px">
          <ant-button block type="danger" native-type="submit">
            提交
          </ant-button>
        </div>
      </ant-form>
    </div>
  </div>
</template>

<script>
import { Image as VanImage } from "vant";
import { Cell, CellGroup, Field, Form, Button, Toast } from "vant";
import footTM from "../../common/footTM";
import service from "../../api/service";
import eventRegistration from "../move/eventRegistration";
import homeHead from "../../common/homeHead";
//个人中心
export default {
  name: "personalCenter",
  components: {
    VanImage,
    Cell,
    CellGroup,
    footTM,
    AntField: Field,
    AntForm: Form,
    AntButton: Button,
    eventRegistration,
    homeHead,
    Toast,
  },
  data() {
    return {
      visible: false,
      form: {
        openid: sessionStorage.getItem("openid"),
        accessToken: "",
        phone: "",
        idNumber: "",
      },
    };
  },
  mounted() {
    this.visible = true;
    this.init();
    let query = this.$route.query;
    if (query.openid) {
      sessionStorage.setItem("openid", query.openid);
      this.form.openid = query.openid;
      this.init();
    } else if (!this.form.openid) {

      window.location.href = service.baseURL + "/api/open";
    } else {
      this.init();
    }
    if (query.access_token) {
      this.$store.state.accessToken = query.access_token;
      this.form.accessToken = query.access_token;
    }
  },
  methods: {
    init() {
      service
        .get("/api/xw/getUserById", {
			//openId:"owgoM53KylxJxJT_Gra_KyYigBv",
          // openId:'owgoM55QDcgG4U075UhjkZEJogw3'
          // openId:'owgoM5__P1Dmi-O92PXJffBI5Qn8'
          // openId:'owgoM5_zM-uVqfbpv--1XcWDB2C4' //1
          // openId: "owgoM5_XxxgaO9et3dSDPEyATaRU",//3
          // openId:'owgoM5_WP_5bRRo2ULy20d01DHjA'//4
          // openId:'owgoM5_vZtLbihA8e1qcrpNuVWok'
          // openId:'owgoM5_vnhEFfPI3lpRQom8SExrI' //2
          openId: sessionStorage.getItem("openid"),
        })
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.toLogin) {
              //没有登录过的用户
              this.$store.state.toLogin = true;
              this.$store.state.user = res.data.user;
              sessionStorage.setItem("phone", res.data.user.phone);
              sessionStorage.setItem("id", res.data.user.id);
              sessionStorage.setItem("deptId", res.data.user.deptId);
              sessionStorage.setItem(
                "permission",
                res.data.permission.toString()
              );
            }
          }
        });
    },
    to(v) {
      this.$router.push({ path: v });
    },
	toWeb(html){
		window.location.href = html
	},
    //登录
    onSubmit() {
      let form = { ...this.form };
      service.post("/api/gzh/login", form).then((res) => {
        if (res.status === 200) {
          Toast.success("登录成功");
          this.init();
          this.$store.state.toLogin = true;
        } else {
          Toast.fail(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.my {
  background-color: #f7f8fa;
  /*min-height: 95vh;*/
}

.my-box {
  position: relative;
  top: 20vh;
  left: 5vw;
  width: 90vw;
}

.my-group {
  border-radius: 10px;
  background-color: #ffffff;
  padding: 3rem 0.2rem 0.2rem 0.2rem;
  position: relative;
}

.my-img {
  position: absolute;
  top: -3rem;
  left: 36vw;
}
</style>